import {
  getInt32,
} from "@surya-digital/leo-ts-types";

export interface OrderDTO {
  order: number;
}

export class Order {
  readonly isOrderOrder: boolean = true;

  readonly order: number;

  static readonly constraints = {
    "order": {
      "minValue": 1,
    }
  }

  constructor(
  order: number
  ) {
    Order.validateOrder(order);
    this.order = order;
  }

  static fromDTO(dto: OrderDTO): Order {
    const order = getInt32(dto, "order", InvalidOrderOrderError);
    return new Order(
      order
    );
  }

  toDTO(): OrderDTO {
    const dto: OrderDTO = {
        order: this.order
    };
    return dto;
  }
  private static validateOrder = (order: number): void => {
    if(order < 1) {
      throw new InvalidOrderOrderMinValueError(
        1,
        `Attribute order has value ${order}. Min value is 1.`
      );
    }
  }
  
}

Order.prototype.toString = function toString(): string {
  return `Order(order='${this.order}')`;
};

export class InvalidOrderError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOrderError";
  }
}
export class InvalidOrderOrderError extends InvalidOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOrderOrderError";
  }
}

export class InvalidOrderOrderMinValueError extends InvalidOrderOrderError {
  readonly minValue: number;
  constructor(minValue: number, message?: string) {
    super(message);
    this.minValue = minValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOrderOrderMinValueError";
  }
}
